import React from "react";

const AgeConfirmModal = ({ onConfirm }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(17, 24, 39, 0.95)",
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: "16px",
          padding: "32px",
          maxWidth: "448px",
          width: "100%",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
          textAlign: "center",
          transform: "translateY(0)",
          transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
        }}
      >
        <h2
          style={{
            fontSize: "1.875rem",
            fontWeight: 700,
            color: "#1f2937",
            marginBottom: "24px",
            lineHeight: "2.25rem",
          }}
        >
          Age Verification
        </h2>
        <p
          style={{
            fontSize: "1.125rem",
            color: "#4b5563",
            marginBottom: "32px",
            lineHeight: "1.75rem",
          }}
        >
          Oracle Games are intended for individuals
          <br />
          <span style={{ fontWeight: 600 }}>18 years or older</span>.<br />
          Please confirm you meet the legal age requirement to continue.
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
          }}
        >
          <button
            style={{
              background: "linear-gradient(90deg, #ef4444, #dc2626)",
              color: "#ffffff",
              border: "none",
              borderRadius: "9999px",
              fontWeight: 600,
              fontSize: "0.875rem",
              padding: "8px 12px",
              cursor: "pointer",
              transition: "background 0.2s ease, transform 0.2s ease",
              outline: "none",
            }}
            onClick={() => onConfirm(false)}
            onMouseOver={(e) =>
              (e.target.style.background =
                "linear-gradient(90deg, #dc2626, #b91c1c)")
            }
            onMouseOut={(e) =>
              (e.target.style.background =
                "linear-gradient(90deg, #ef4444, #dc2626)")
            }
            onFocus={(e) =>
              (e.target.style.boxShadow = "0 0 0 3px rgba(239, 68, 68, 0.3)")
            }
            onBlur={(e) => (e.target.style.boxShadow = "none")}
            aria-label="Deny age 18 or older"
          >
            ❌ No, I am under 18
          </button>
          <button
            style={{
              background: "linear-gradient(90deg, #10b981, #059669)",
              color: "#ffffff",
              border: "none",
              borderRadius: "9999px",
              fontWeight: 600,
              fontSize: "0.875rem",
              padding: "8px 12px",
              cursor: "pointer",
              transition: "background 0.2s ease, transform 0.2s ease",
              outline: "none",
            }}
            onClick={() => onConfirm(true)}
            onMouseOver={(e) =>
              (e.target.style.background =
                "linear-gradient(90deg, #059669, #047857)")
            }
            onMouseOut={(e) =>
              (e.target.style.background =
                "linear-gradient(90deg, #10b981, #059669)")
            }
            onFocus={(e) =>
              (e.target.style.boxShadow = "0 0 0 3px rgba(16, 185, 129, 0.3)")
            }
            onBlur={(e) => (e.target.style.boxShadow = "none")}
            aria-label="Confirm age 18 or older"
          >
            ✅ Yes, I am 18 or older
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeConfirmModal;
